import { THEME } from 'styles/themes';

export const colors = THEME.UserCountdown.colors ?? {};
